import { CONSENTS, ConsentKeys } from '../types/consents';

export const getSavedConsents = (): Record<ConsentKeys, boolean> => {
	const ids = Object.values(CONSENTS);

	return ids.reduce(
		(acc, id) => ({
			[id]: sessionStorage.getItem(id) === 'true',
			...acc,
		}),
		{} as Record<ConsentKeys, boolean>,
	);
};
